import PrimaryButton from '../../../../../../components/common/PrimaryButton/PrimaryButton'
import DataTable from 'react-data-table-component'
import { MdDeleteForever } from "react-icons/md";

const AddedCustomers = () => {

  const data = [
    { id: '001', name: 'Lorem ipsum', email: 'Loremipsum@gmail.com', phoneNo: '03411234560', status: "Active" },
    { id: '001', name: 'Lorem ipsum', email: 'Loremipsum@gmail.com', phoneNo: '03411234560', status: "Active" },
    { id: '001', name: 'Lorem ipsum', email: 'Loremipsum@gmail.com', phoneNo: '03411234560', status: "Active" },
    { id: '001', name: 'Lorem ipsum', email: 'Loremipsum@gmail.com', phoneNo: '03411234560', status: "Active" },
    { id: '001', name: 'Lorem ipsum', email: 'Loremipsum@gmail.com', phoneNo: '03411234560', status: "Active" },
  ]

  const columns = [
    { name: 'Customer ID', selector: row => row.id },
    { name: 'Customer name', selector: row => row.name },
    { name: 'Email Address', selector: row => row.email },
    { name: 'Phone number', selector: row => row.phoneNo },
    { name: 'Status', selector: row => row.status },
    { name: "Action", cell: row => <div className='cursor-pointer'><MdDeleteForever size={24} /></div>, button: true }
  ]

  const customStyles = {
    headCells: {
      style: {
        backgroundColor: "#f2f2f2",
        fontSize: "0.938rem",
        fontWeight: 500,
      },
    },
    cells: {
      style: {
        paddingBlock: "1rem",
      },
    },
  }

  return (
    <div>
      <div className='d-flex justify-content-between align-items-center'>
        <div>Total Added Customer: 4</div>
        <PrimaryButton name="Add" />
      </div>

      <div>
        <DataTable data={data} columns={columns} customStyles={customStyles} />
      </div>
    </div>
  )
}

export default AddedCustomers